import Auth from '@/views/Auth'
import PasswordReset from '@/views/PasswordReset'
import Home from '@/views/Home'
import { siteName } from '@/config/app'

const Dashboard = () => import('@/views/Dashboard')
const Templates = () => import('@/views/Templates')
const FormLoader = () => import('@/views/FormLoader')
const NewDocument = () => import('@/views/NewDocument')
const ManageClients = () => import('@/views/ManageClients')
const ManageInvitations = () => import('@/views/ManageInvitations')
const AccountAdminUsers = () => import('@/views/AccountAdminUsers')
const Accounts = () => import('@/views/Accounts')
const OLAdmin = () => import('@/views/OLAdmin')
const Admin = () => import('@/views/Admin')
const RegisterWrapper = () => import('@/views/RegisterWrapper')
const RegisterDocuments = () => import('@/components/RegisterDocuments')
const RegisterDocumentsInfoPane = () =>
  import('@/components/RegisterDocumentsInfoPane')
const RegisterAssets = () => import('@/components/RegisterAssets')
const RegisterAssetsInfoPane = () =>
  import('@/components/RegisterAssetsInfoPane')
const ShareRegisterWrapper = () => import('@/views/ShareRegisterWrapper')
const FindALawyer = () => import('@/views/FindALawyer')
const InactiveAccount = () => import('@/views/InactiveAccount')
const SignUp = () => import('@/views/SignUp')
const EmbeddedSignUp = () => import('@/views/EmbeddedSignUp')
const Invited = () => import('@/views/Invited')
const AccountStatus = () => import('@/views/AccountStatus')
const ManageMfa = () => import('@/views/ManageMfa')

const routes = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: Dashboard,
          meta: {
            title: 'Dashboard',
            helpUrl: 'https://www.authentigate.io/help-center-1/welcome'
          }
        },
        {
          path: '/new/:templateId/:uid?',
          name: 'newDocument'
        },
        {
          path: '/document/new/:templateName?',
          name: 'documentsNew',
          component: NewDocument,
          meta: { title: 'New Document' }
        },
        {
          path: '/documents/:documentId/:new?',
          component: FormLoader,
          name: 'documents',
          meta: { title: 'Document' },
          props: true
        },
        {
          path: '/oladmin/templates',
          component: Templates,
          meta: { title: 'Manage Templates' }
        },
        {
          path: '/oladmin',
          component: OLAdmin,
          meta: { title: `${siteName} Admin` }
        },
        {
          path: '/admin',
          component: Admin,
          name: 'admin',
          meta: { title: 'Account Admin' },
          props: true
        },
        {
          path: '/users',
          component: AccountAdminUsers,
          name: 'users',
          meta: { title: 'Manage Users' },
          props: true
        },
        {
          path: '/oladmin/accounts',
          component: Accounts,
          meta: { title: 'Manage Accounts' },
          name: 'accounts'
        },
        {
          path: '/clients',
          component: ManageClients,
          meta: { title: 'Manage Clients' },
          name: 'clients',
          props: true
        },
        {
          path: '/invitations',
          component: ManageInvitations,
          meta: { title: 'Manage Invitations' },
          name: 'invitations',
          props: true
        },
        {
          path: '/account-status',
          component: AccountStatus,
          meta: { title: 'Account Status' },
          name: 'accountStatus'
        },
        {
          path: '/manage-mfa',
          component: ManageMfa,
          meta: { title: 'Manage MFA' },
          name: 'manageMfa'
        },
        {
          path: '/oladmin/accounts/users',
          component: Accounts,
          meta: { title: 'Manage Account Users' },
          name: 'accounts/users'
        },
        {
          path: 'oladmin/accounts/clients',
          component: Accounts,
          meta: { title: 'Manage Account Clients' },
          name: 'accounts/clients'
        },
        {
          path: '/register',
          component: RegisterWrapper,
          meta: { title: 'Register' },
          children: [
            {
              path: 'documents',
              name: 'register.documents',
              meta: { title: 'Register / Documents' },
              component: RegisterDocuments,
              children: [
                {
                  path: ':documentId',
                  name: 'register.documents.info',
                  meta: { title: 'Register / Documents' },
                  component: RegisterDocumentsInfoPane,
                  props: true
                }
              ]
            },
            {
              path: 'assets',
              name: 'register.assets',
              meta: { title: 'Register / Assets' },
              component: RegisterAssets,
              children: [
                {
                  path: ':assetId',
                  name: 'register.assets.info',
                  meta: { title: 'Register / Assets' },
                  component: RegisterAssetsInfoPane,
                  props: true
                }
              ]
            }
          ],
          redirect: {
            name: 'register.documents'
          }
        },
        {
          path: '/share-register',
          component: ShareRegisterWrapper,
          meta: { title: 'Share Register' },
          name: 'shareregister'
        },
        {
          path: '/findalawyer',
          component: FindALawyer,
          meta: { title: 'Find a Lawyer' },
          name: 'findalawyer'
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      meta: { title: 'Log-in', public: true },
      component: Auth
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      meta: { title: 'Password Reset', public: true },
      component: PasswordReset
    },
    {
      path: '/signup',
      name: 'signup',
      meta: { title: 'Sign Up', public: true },
      component: SignUp
    },
    {
      path: '/embedded-signup',
      name: 'embeddedSignup',
      meta: { title: 'Sign Up', public: true },
      component: EmbeddedSignUp
    },
    {
      path: '/inactiveaccount',
      component: InactiveAccount,
      meta: { title: 'Inactive Account' },
      name: 'inactiveaccount'
    },
    {
      path: '/invited/:inviteToken',
      component: Invited,
      meta: { title: `Welcome to ${siteName}`, public: true },
      name: 'invited'
    }
  ]
}

export default routes
